import { InputType } from '@import/enums/input-type.enum';
import { BooleanOption, ColumnType } from '@import/interfaces';
import { DataField } from '@models/settings/data-field.model';
import { DataFieldTypes } from '@app/enums/data-field-types.enum';

export const dataFieldToColumnType = (dataField: DataField): ColumnType => {
    const rules = dataField.rules.split('|');
    const inputType = rules[0];

    const columnType: ColumnType = {
        label: dataField.name,
        serializeName: 'dataValues.' + dataField.id,
        required: false, // This is being hard-coded to false see: SQA-2908
        input: InputType[inputType],
        rules: rules.map((rule) => rule.split(':')),
    };

    if (dataField.type === DataFieldTypes.longText) {
        columnType.input = InputType.longText;
    }

    if (dataField.type === DataFieldTypes.dropdown) {
        columnType.input = InputType.options;
        columnType.options = dataField.getFormattedDropdownOption();
    }

    if (inputType === InputType.boolean) {
        columnType.options = BooleanOption;
    }

    return columnType;
};
